// extracted by mini-css-extract-plugin
module.exports = {"button":"AuthButton_button__3FEBJ","active":"AuthButton_active__2YlMY"};